import { Spinner } from "@/components/data-state";
import { GoalBadge } from "@/components/goal-badge";
import { Badge } from "@/components/ui/badge";
import type { Submission } from "@/lib/api";
import { isPending } from "@/lib/api";

/**
 * One badge that says what became of a run.
 *
 * `GoalBadge` alone cannot: it only knows the tier, and the tier is null for a
 * queued run, a running one, and a rejected one alike -- so three different
 * situations all read "Not scored". This tells them apart.
 */
export function RunOutcome({
  submission,
  className,
}: {
  submission: Pick<Submission, "status" | "goal_tier">;
  className?: string;
}) {
  if (submission.status === "failed") {
    return (
      <Badge variant="destructive" className={className}>
        Failed
      </Badge>
    );
  }
  if (isPending(submission.status)) {
    return (
      <Badge variant="secondary" className={`gap-1.5 ${className ?? ""}`}>
        <Spinner className="size-3" />
        {submission.status === "queued" ? "Queued" : "Evaluating"}
      </Badge>
    );
  }
  return (
    <GoalBadge tier={submission.goal_tier} className={className} />
  );
}
